export const spacing01 = '4px';
export const spacing02 = '8px';
export const spacing03 = '12px';
export const spacing04 = '16px';
export const spacing05 = '24px';
export const spacing06 = '32px';
export const spacing07 = '48px';
export const spacing08 = '64px';
export const spacing09 = '96px';
export const spacing10 = '128px';
export const spacing11 = '192px';
export const spacing12 = '256px';
export const spacing13 = '384px';
export const spacing14 = '512px';
export const spacing15 = '640px';
export const spacing16 = '768px';
export const spacing17 = '1024px';
